import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from "rxjs";
import { LocationsRepository } from "../../repositories";

@Injectable({providedIn: 'root'})
export class DeactivatePublicLocationUsecase implements UseCase<string, boolean> {

    constructor(private _locationRepository: LocationsRepository){}

    execute(publicLocationId:string):Observable<boolean>{
        return this._locationRepository.deactivatePublicLocation(publicLocationId);
    }
}
